import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AboutRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/about/company');
  }, []);
  return <div></div>;
};

export default AboutRedirect;
